export const consentsSk = {
  // Direct translations for consent types - can be used with transloco
  PRIVACY_POLICY: 'Zásady ochrany súkromia',
  TERMS_OF_USE: 'Podmienky používania',
  MARKETING: 'Marketingová komunikácia',
  AI_MATCHING: 'AI párovanie pracovných pozícií',
  AI_PARSING: 'AI analýza životopisu',
  COOKIES: 'Cookies',
  ANALYTICS: 'Analýzy a štatistiky',
  THIRD_PARTY_SHARING: 'Zdieľanie údajov s tretími stranami',

  // Descriptions
  descriptions: {
    PRIVACY_POLICY: 'Súhlas so Zásadami ochrany súkromia je potrebný pre používanie našich služieb a spracovanie vašich osobných údajov.',
    TERMS_OF_USE: 'Súhlas s Podmienkami používania je povinný pre prístup a používanie našich služieb.',
    MARKETING: 'Dostávajte propagačné e-maily, newslettery a marketingovú komunikáciu o našich službách, pracovných príležitostiach a špeciálnych ponukách.',
    AI_MATCHING:
      'Keď je zapnuté, Sameta môže analyzovať váš profil, údaje zo životopisu, preferencie a aktivitu, aby vám odporúčala relevantné pracovné ponuky a podporila AI párovanie pre recruiterov. Vypnite ho, ak nechcete automatizované párovanie.',
    AI_PARSING:
      'Keď je zapnuté, Sameta môže použiť AI na prečítanie nahraného životopisu a predvyplnenie polí profilu. Šetrí to čas pri úprave profilu a je to oddelené od AI párovania.',
    COOKIES: 'Povoľte nám používať cookies na zlepšenie vášho zážitku z prehliadania, zapamätanie si preferencií a poskytovanie personalizovaného obsahu.',
    ANALYTICS: 'Povoľte nám zbierať anonymné štatistiky používania a analytické údaje na zlepšenie našich služieb a pochopenie správania používateľov.',
    THIRD_PARTY_SHARING: 'Povoľte nám zdieľať vaše údaje s dôveryhodnými partnermi za účelom párovanosti pracovných pozícií a náboru.',
  },

  // UI labels and content
  pages: {
    settings: {
      consents: {
        title: 'Správa súhlasov',
        description:
          'Spravujte svoje preferencie ochrany súkromia a súhlasy so spracovaním údajov. Súhlas s rôznymi aktivitami spracovania údajov môžete kedykoľvek udeliť alebo odvolať.',
        loading: 'Načítavam vaše preferencie súhlasov...',
        categories: {
          essential: 'Základné súhlasy',
          essentialDescription: 'Tieto súhlasy sú potrebné pre základnú funkčnosť našich služieb a nie je možné ich vypnúť.',
          optional: 'Voliteľné súhlasy',
          optionalDescription: 'Tieto súhlasy sú voliteľné a pomáhajú nám zlepšovať naše služby. Môžete ich kedykoľvek povoliť alebo zakázať.',
        },
        grantedOn: 'Udelené dňa',
        withdrawnOn: 'Odvolané dňa',
        version: 'Verzia',
        required: 'Povinné',
        footerInfo:
          'Zmeny vašich preferencií súhlasov sa prejavia okamžite. Tieto nastavenia môžete kedykoľvek upraviť. Pre viac informácií o tom, ako spracovávame vaše údaje, si prečítajte naše',
      },
    },
  },
};
